import { render, staticRenderFns } from "./ServiceValidation.vue?vue&type=template&id=3d56a9f8&"
import script from "./ServiceValidation.vue?vue&type=script&lang=js&"
export * from "./ServiceValidation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports